import { Component } from '@angular/core';

@Component({
  selector: 'pc-homepage-circles',
  standalone: true,
  imports: [],
  templateUrl: './homepage-circles.component.html',
  styleUrl: './homepage-circles.component.scss'
})
export class HomepageCirclesComponent {

}
